var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiLinkedinFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4565 7.77901C12.4561 8.51568 12.1683 9.22204 11.6564 9.74268C11.1445 10.2633 10.4504 10.5556 9.72686 10.5552C9.00329 10.5549 8.3095 10.2619 7.79811 9.74072C7.28673 9.21955 6.99964 8.51291 7 7.77624C7.00036 7.03956 7.28815 6.33321 7.80004 5.81257C8.31194 5.29192 9.00602 4.99963 9.72959 5C10.4532 5.00037 11.147 5.29336 11.6583 5.81453C12.1697 6.3357 12.4568 7.04234 12.4565 7.77901ZM12.5383 12.6121H7.08185V30H12.5383V12.6121ZM21.1595 12.6121H15.7303V30H21.1049V20.8755C21.1049 15.7925 27.6118 15.3203 27.6118 20.8755V30H33V18.9867C33 10.4178 23.3694 10.7372 21.1049 14.9453L21.1595 12.6121Z",
    fill: "#2C6199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiLinkedinFill);
export default __webpack_public_path__ + "static/media/ri_linkedin-fill.f72ac229667c9bd3019c9fd8c6bb984f.svg";
export { ForwardRef as ReactComponent };